// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { CheckmarkDataSrc } from "@store/Library/Components/Toolkit/Icons/Checkmark";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const lists: Styleguide["lists"] = {
    defaultProps: {
        css: css`
            ${spacingStyles()}
            padding-left: 1em;

            li {
                ${spacingStyles(null, "0.25em")}
                padding-left: 0;

                > ul,
                > ol {
                    margin-top: 0.25em;
                }
            }

            &[class*="icon-"] {
                padding-left: 0;

                > li {
                    display: flex;
                    align-items: flex-start;

                    &::before {
                        content: "\00a0";
                        flex-shrink: 0;
                        width: 1.5em;
                        mask-repeat: no-repeat;
                        mask-position: 50% 50%;
                        background-color: ${getColor("secondary")};
                        margin-right: 0.5em;
                    }
                }
            }

            &[class*="icon-checkmark"] > li::before {
                mask-image: url(${CheckmarkDataSrc});
            }
        `,
    },
};

export default lists;
